module.exports = __webpack_public_path__ + "static/img/p-s4-1.be6228c0.png";